import * as Tool from './tool'
export const isBoe = window.location.host.includes('boe')
const getOrigin = (p, d) => Tool.getConf('CDN_DOMAIN', p, d)
const getSrc = domain => (uri) => `${domain}${uri}`

// img-ttcdn
// .png, .jpg, ... ..., .excel
const ttpstatpImgOrigin = getOrigin('IMG_TTCDN_TOS', '//sf1-ttcdn-tos.pstatp.com/')

// img-byteimg
// .png, .jpg, ... ...
const byteImgOrigin = getOrigin('IMG_BYTE_IMG', '//p1-oe.byteimg.com/')

// img-other
const sPstatpImgOrigin = getOrigin('IMG_OTHER_SPSTATP', '//s2.pstatp.com/')
const pPstatpImgOrigin = getOrigin('IMG_OTHER_PPSTATP', '//p0.pstatp.com/')

// creative-material uri -> url
// const creativeMaterialOrigin = getOrigin('CREATIVE_MATERIAL', '//sf1-ttcdn-tos.pstatp.com/')

// change-cdn
const imageUrl = getOrigin('CREATIVE_MATERIAL_V2', isBoe ? '//tosv.boe.byted.org/' : '//p3-adplatform.byteadimg.com/')

// creative-material-legacy uri -> url
// const creativeMaterialLegacyOrigin = getOrigin('CREATIVE_MATERIAL_LEGACY', '//sf1-ttcdn-tos.pstatp.com/')

// video
// .wav .mp4
const ttpstatpVideoOrigin = getOrigin('VIDEO_TTCDN_TOS', '//sf1-ttcdn-tos.pstatp.com/')

// js
const ttpstatpJsOrigin = getOrigin('JS_TTCDN_TOS', '//sf1-ttcdn-tos.pstatp.com/')

const pstatpJsOrigin = getOrigin('JS_SPSTATP', '//s2.pstatp.com/')

// css
const pstatpCssOrigin = getOrigin('CSS_SPSTATP', '//s2.pstatp.com/')

// 二进制等静态文件：如 excel
// cdn 管理地址：https://cloud.bytedance.net/cdn
const dypstatpObjOrigin = getOrigin('OBJ_DYCDN_TOS', '//sf1-dycdn-tos.pstatp.com/')

// IMC js,img
const imchscdnOrigin = getOrigin('IMC_HSCDN_TOS', '//lf3-beecdn.bytetos.com/')

// 各种异常资源情况
const SOURCE_DOMAIN = {
  // .png, .jpg,... ...
  IMG_OTHER: {
    sp: sPstatpImgOrigin,
    pp: pPstatpImgOrigin
  }
}

// 通用可随时切换的资源地址

// sf*-ttcdn-tos.pstatp.com
const GET_IMG_TT_SRC = getSrc(ttpstatpImgOrigin)

// p*-oe.byteimg.com
const GET_IMG_BYTE_SRC = getSrc(byteImgOrigin)

// sf*-ttcdn-tos.pstatp.com
const GET_JS_TT_SRC = getSrc(ttpstatpJsOrigin)

// sf*-ttcdn-tos.pstatp.com
const GET_CREATIVE_MATERIAL = uri => {
  if (!uri) return
  let realOrigin = imageUrl
  const prefix = 'obj/'
  let realUri = uri
  if (uri.indexOf('/') === -1) {
    realOrigin = imageUrl
    realUri = `mosaic-legacy/${uri}`
  }
  return `${document.location.protocol}${getSrc(realOrigin)(`${prefix}${realUri}`)}`
}

// 暂时认为两者的域名一致
const GET_CREATIVE_OPT_MATERIAL = uri => {
  if (!uri) return
  let realOrigin = imageUrl
  const prefix = 'img/'
  let realUri = `${uri}`
  if (uri.indexOf('/') === -1) {
    realOrigin = imageUrl
    realUri = `mosaic-legacy/${uri}`
  }
  return `${document.location.protocol}${getSrc(realOrigin)(`${prefix}${realUri}`)}`
}

// s*.pstatp.com
const GET_JS_SRC = getSrc(pstatpJsOrigin)

// s2.pstatp.com/只有这一个，可以考虑替换
const GET_CSS_SRC = getSrc(pstatpCssOrigin)

// sf*-ttcdn-tos.pstatp.com
const GET_VIDEO_SRC = getSrc(ttpstatpVideoOrigin)

const GET_OBJ_DYCDN_TOS = getSrc(dypstatpObjOrigin)

const GET_IMC_SRC = getSrc(imchscdnOrigin)

const registerArr = {
  SOURCE_DOMAIN,
  GET_IMG_TT_SRC,
  GET_IMG_BYTE_SRC,
  GET_JS_TT_SRC,
  GET_CREATIVE_MATERIAL,
  GET_CREATIVE_OPT_MATERIAL,
  GET_JS_SRC,
  GET_CSS_SRC,
  GET_VIDEO_SRC,
  GET_OBJ_DYCDN_TOS,
  GET_IMC_SRC
}

Tool.registerFactory(registerArr)

Vue.mixin({
  data () {
    return {
      SOURCE_DOMAIN
    }
  },
  methods: {
    GET_IMG_TT_SRC,
    GET_IMG_BYTE_SRC,
    GET_CREATIVE_MATERIAL,
    GET_CREATIVE_OPT_MATERIAL,
    GET_JS_TT_SRC,
    GET_JS_SRC,
    GET_CSS_SRC,
    GET_VIDEO_SRC,
    GET_OBJ_DYCDN_TOS,
    GET_IMC_SRC
  }
})
